import { ErrorText } from '@presentation/components';
import { hasFieldError } from '@presentation/utils';
import { useField } from 'formik';
import type { FC } from 'react';
import { useCallback, useMemo, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import * as Styled from './styled';
import type { InputStarsFieldProps } from './types';

export * from './types';

export const InputStarsField: FC<InputStarsFieldProps> = (props) => {
  const { name, tooltips } = props;
  const [field, meta, helpers] = useField<number>(name);

  const [tempValue, setTempValue] = useState<number | undefined>(field.value);

  const mouseClickHandler = useCallback(
    (index: number) => {
      helpers.setValue(index + 1);
    },
    [helpers],
  );

  const mouseOverHandler = useCallback(
    (index: number) => {
      setTempValue(index + 1);
    },
    [setTempValue],
  );

  const blurHandler = useCallback(() => {
    setTempValue(undefined);
  }, [setTempValue]);

  const tooltip = useMemo((): string | undefined => {
    if (!tooltips?.length) return;
    if (tempValue == null) return;
    return tooltips[tempValue - 1];
  }, [tempValue, tooltips]);

  return (
    <>
      {!!tooltip && <Tooltip id={`tooltip-${name}`} />}
      <Styled.IconScaleStars
        amount={tempValue != null ? tempValue : field.value}
        onClick={mouseClickHandler}
        onMouseOver={mouseOverHandler}
        onMouseOut={blurHandler}
        {...(tooltip
          ? { 'data-tooltip-content': tooltip, 'data-tooltip-id': `tooltip-${name}` }
          : {})}
      />
      {hasFieldError(meta) && <ErrorText>{meta.error}</ErrorText>}
    </>
  );
};
